export function LiveKitDebugPage() {
  return (
    <iframe
      src="/livekit-debug.html"
      title="LiveKit Connection Debug"
      style={{ position: "fixed", inset: 0, width: "100%", height: "100%", border: 0 }}
    />
  );
}